/**
 * Menu
 */
class Menu {
  constructor () {
    this.$menu = $('#menu-main')
    
    this.init()
  }
  
  init () {
    //  create menu html at mobile device
    this._createHtml()
    //  event handle
    this._eventHandle()
  }
  
  /**
   * handle for new menu btn click
   * @private
   */
  _eventHandle () {
    this.$input = $('.js-search-text-input')
    this.$close = $('.munuMobile__search--close')
    
    $('.menuMobileBox__btn--menu').on('click', () => {
      // $('#genesis-mobile-nav-secondary').click()
      $(window).trigger($.Event('menuClick'))
    })
    
    
    $('.munuMobile__search').click(ev => {
      if (this.$input.css('display') === 'none') {
        this.$input.fadeIn(() => this.$close.show())
        ev.preventDefault()
      }
    })
    
    this.$close.click(ev => {
      this.$input.fadeOut()
      this.$close.hide()
    })
  }
  
  /**
   * create menu html at mobile device
   */
  _createHtml () {
    let oMenuClone = this.$menu.clone()
    let oSearchInput = $('.widget_search input[type="search"]')
    let isUsePlaceHolder = oSearchInput.attr('placeholder') ? true : false
    
    let html = `<section class="menuMobileBox d-md-none">
                    <div class="menuMobileBox__item--left">
                        <button class="menuMobileBox__btn--menu">
                            <span class="dashicons dashicons-menu"></span>
                            <span class="dashicons dashicons-no-alt"></span>
                        </button>
                        <ul class="menuMobile">${oMenuClone.html()}</ul>
                    </div>
                    <div class="menuMobileBox__item--right">
                      <button class="menuMobileBox__btn--lang"></button>
                      <form class="search-input jst input-group" id="js-search-text" action="/">
                          <input autocomplete="off"
                                 type="search"
                                 class="form-control js-search-text-input"
                                 name="s" placeholder="${isUsePlaceHolder ? oSearchInput.attr('placeholder') : ''}"
                                 value="${!isUsePlaceHolder ? oSearchInput.val() : ''}">
                          <button class="munuMobile__search" type="submit"></button>
                      </form>
                      <button class="munuMobile__search--close"><span class="dashicons dashicons-no-alt"></span></button>
                    </div>
                </section>`
    
    $('.site-container-wrap').prepend(html)
  }
  
}

export default Menu
